'use client';

import { useEffect } from 'react';

import { getENV } from '@libs/common-next';

export function Release() {
    const { NEXT_PUBLIC_RELEASE_VERSION, NEXT_PUBLIC_COMMIT_SHA } = getENV();

    useEffect(() => {
        window.__release = { version: NEXT_PUBLIC_RELEASE_VERSION, commit: NEXT_PUBLIC_COMMIT_SHA };
    }, []);

    return (
        <>
            <meta name="x-petm-release" content={NEXT_PUBLIC_RELEASE_VERSION} />
            <meta name="x-petm-commit" content={NEXT_PUBLIC_COMMIT_SHA} />
        </>
    );
}
